import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => {
        console.error('====== BOOTSTRAP ERROR ======');
        console.error('Error Type:', err.name);
        console.error('Error Message:', err.message);
        console.error('Full Error:', err);
        console.error('Stack Trace:', err.stack);
        console.error('============================');
    });

/**
 * Enable debugging of tick cycle times:
 * enable following line and in dev console run command: ng.profiler.timeChangeDetection()
 * notes: https://itnext.io/heres-how-to-find-the-change-detection-bottle-necks-in-your-angular-application-333a71758477
 *
 * import {enableDebugTools} from "@angular/platform-browser";
 * import {ApplicationRef, enableProdMode} from '@angular/core';
 * platformBrowserDynamic().bootstrapModule(AppModule).then(module => enableDebugTools(module.injector.get(ApplicationRef).components[0])).catch(err => console.error(err));
 *
 **/

